import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useRef } from 'react';
import { Controller, useWatch } from 'react-hook-form';
import { InfoIcon, MenuItem, Select, TextField, Typography, useDidUpdate } from 'seagull';
import { getCustomMessageValidation } from '~/business-logic/validators';
import { useLocaleKeys } from '~/i18n';
import { connectControllerToTextField } from '~/utils/react-hook-form.utils';
import styles from './IntroductoryMessageEditor.module.scss';
const messageRules = getCustomMessageValidation('Introductory message', false);
/** This component is meant to work exclusively with `react-hook-form`.
 * It's your responsibility to provide the form field name keys (which probably correspond to the template names in some way).
 * Each template's text content (= value) is provided by the containing form. */ export default function IntroductoryMessageEditor(param) {
    let { formState, control, selectedTemplateFormFieldName, label, templates, onStartEditingReadOnlyTemplate, testPrefix = 'intro-message-editor' } = param;
    const { t: proposalDefaultsTexts } = useLocaleKeys('pages.proposalDefaults');
    const resolvedLabel = label !== null && label !== void 0 ? label : proposalDefaultsTexts.introductoryMessageTemplates();
    const selectedTemplateName = useWatch({
        control,
        name: selectedTemplateFormFieldName
    });
    const refs = useRef({});
    useDidUpdate(()=>{
        var _refs_current_selectedTemplateName;
        const target = (_refs_current_selectedTemplateName = refs.current[selectedTemplateName]) === null || _refs_current_selectedTemplateName === void 0 ? void 0 : _refs_current_selectedTemplateName.querySelector('textarea');
        if (target) {
            // a hack to move the cursor to the end
            const currentValue = target.value;
            target.value = '';
            target.value = currentValue;
        }
        target === null || target === void 0 ? void 0 : target.focus();
    }, [
        selectedTemplateName
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: styles.fieldWithTooltip,
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        children: resolvedLabel
                    }),
                    /*#__PURE__*/ _jsx(InfoIcon, {
                        info: proposalDefaultsTexts.introMessageInfo()
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Controller, {
                control: control,
                name: selectedTemplateFormFieldName,
                render: (props)=>/*#__PURE__*/ _jsx(Select, _object_spread_props(_object_spread({
                        bi: {
                            name: 'introductory_message_template'
                        },
                        collapseHelperText: false
                    }, connectControllerToTextField(props)), {
                        disabled: !formState.isValid,
                        testId: "".concat(testPrefix, "-dropdown"),
                        children: templates.map((param, i)=>{
                            let { dropdownLabel, name } = param;
                            return /*#__PURE__*/ _jsx(MenuItem, {
                                value: name,
                                testId: "".concat(testPrefix, "-dropdown-option-").concat(i),
                                children: dropdownLabel
                            }, name);
                        })
                    }))
            }),
            templates.map((param)=>{
                let { name } = param;
                return /*#__PURE__*/ _jsx("div", {
                    hidden: selectedTemplateName !== name,
                    style: {
                        gridColumn: 'span 2'
                    },
                    ref: (el)=>{
                        return refs.current && (refs.current[String(name)] = el);
                    },
                    children: /*#__PURE__*/ _jsx(Controller, {
                        control: control,
                        name: name,
                        rules: messageRules,
                        render: (props)=>{
                            const _connectControllerToTextField = connectControllerToTextField(props), { onChange } = _connectControllerToTextField, connect = _object_without_properties(_connectControllerToTextField, [
                                "onChange"
                            ]);
                            return /*#__PURE__*/ _jsx(TextField, _object_spread_props(_object_spread({
                                bi: {
                                    name: 'introductory_message_content'
                                },
                                collapseHelperText: false
                            }, connect), {
                                onChange: (e)=>{
                                    const template = templates.find((param)=>{
                                        let { name } = param;
                                        return name === selectedTemplateName;
                                    });
                                    if (template === null || template === void 0 ? void 0 : template.readOnly) {
                                        onStartEditingReadOnlyTemplate && onStartEditingReadOnlyTemplate(name);
                                    } else {
                                        onChange(e);
                                    }
                                },
                                testId: "".concat(testPrefix, "-").concat(name),
                                placeholder: proposalDefaultsTexts.messagePlaceholder(),
                                multiline: true,
                                minRows: 6,
                                maxRows: 12
                            }));
                        }
                    })
                }, name);
            })
        ]
    });
}
